var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mb-6"},[_c('v-card-title',{staticClass:"px-5"},[_vm._v("Select date period")]),_c('v-card-actions',{staticClass:"px-5"},[_c('base-period-select',{on:{"onSelect":_vm.updatePeriod}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }